import { Button } from "@/components/ui/button";
import { ThemeCard } from "./ThemeCard";
import { colorSchemes, proColorSchemes } from "../constants";
import { Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Separator } from "@/components/ui/separator";
import { ProFeatureWrapper } from "../ProFeatureWrapper";
import type { ColorScheme } from "../types";
interface ThemeSelectorProps {
  selectedTheme: string;
  isPro: boolean;
  isUpgrading: boolean;
  showBadge: boolean;
  onThemeSelect: (theme: string) => void;
  onUpgrade: () => void;
  onBadgeToggle: (show: boolean) => void;
}
export const ThemeSelector = ({
  selectedTheme,
  isPro,
  isUpgrading,
  showBadge,
  onThemeSelect,
  onUpgrade,
  onBadgeToggle
}: ThemeSelectorProps) => {
  return <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">Témák</h3>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {Object.entries(colorSchemes).map(([key, scheme]) => <ThemeCard key={key} scheme={scheme} isSelected={selectedTheme === key} isPro={isPro} isProTheme={false} onClick={() => onThemeSelect(key)} />)}
      </div>

      <ProFeatureWrapper feature="pro themes" isPro={isPro}>
        <div className="grid grid-cols-2 gap-4">
          {Object.entries(proColorSchemes).map(([key, scheme]) => <ThemeCard key={key} scheme={scheme} isSelected={selectedTheme === key} isPro={isPro} isProTheme={true} onClick={() => onThemeSelect(key)} />)}
        </div>
      </ProFeatureWrapper>

      <Separator />

      <ProFeatureWrapper feature="badge customization" isPro={isPro}>
        <div className="flex items-center space-x-2">
          <Switch id="show-badge" checked={showBadge} onCheckedChange={onBadgeToggle} />
          <Label htmlFor="show-badge">Pageflo jelzés megjelenítése</Label>
        </div>
      </ProFeatureWrapper>
    </div>;
};